'use strict';

import { slideToggle } from "../functions.js";

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.menu');
  const menuToggle = document.querySelector('.header__menu-toggle');
  const btnSubmenu = document.querySelectorAll('.menu__button');

  const searchForm = document.querySelector('.search-form');
  let flagClickMenu = false;

  menuToggle.addEventListener('click', () => {
    if (!menu.closest('.menu--opened')) {
      if (!searchForm.closest('.search-form--opened')) {
        document.body.classList.add('no-scroll');
        menu.classList.add('menu--opened');
        menuToggle.classList.add('header__menu-toggle--opened');
        return false;
      }

      searchForm.classList.remove('search-form--opened');
      flagClickMenu = true;
    } else {
      menu.classList.remove('menu--opened');
      menuToggle.classList.remove('header__menu-toggle--opened');
      flagClickMenu = false;
    }
  });

  searchForm.addEventListener('transitionend', (e) => {
    if (flagClickMenu && !searchForm.closest('.search-form--opened') && e.propertyName === 'transform') {
      document.body.classList.add('no-scroll');
      menu.classList.add('menu--opened');
      menuToggle.classList.add('header__menu-toggle--opened');
    }
  });

  window.addEventListener('keydown', (e) => {
    if (e.code === 'Escape' && menu.closest('.menu--opened')) {
      menu.classList.remove('menu--opened');
      menuToggle.classList.remove('header__menu-toggle--opened');
      flagClickMenu = false;
    }
  });

  menu.addEventListener('transitionend', (e) => {
    if (!menu.closest('.menu--opened') && e.propertyName === 'opacity') {
      document.body.classList.remove('no-scroll');
    }
  });

  btnSubmenu.forEach((item) => {
    item.addEventListener('click', (e) => {
      if(document.body.clientWidth < 768) {
        e.preventDefault();
        e.target.classList.toggle('menu__button--open');
        e.target.previousElementSibling.classList.toggle('menu__link--open');
        slideToggle(e.target.nextElementSibling);
      }
    })
  })

  let widthWindow = window.outerWidth;
  window.addEventListener('resize', () => {
    if(widthWindow !== window.outerWidth) {
      document.body.classList.remove('no-scroll');
      menu.classList.remove('menu--opened');
      menuToggle.classList.remove('header__menu-toggle--opened');
      btnSubmenu.forEach((item) => item.classList.remove('menu__button--open'));
      document.querySelectorAll('.menu__link--open').forEach((item) => item.classList.remove('menu__link--open'));
      document.querySelectorAll('.submenu').forEach((item) => item.removeAttribute('style'));
      flagClickMenu = false;
    }
  });

  const submenus = document.querySelectorAll('.menu__dropdown .submenu');
  submenus.forEach((submenu) => {
    let countItems = submenu.querySelectorAll('.submenu__item').length;
    if(countItems > 9) {
      submenu.classList.add('submenu--big');
    }
  });
});